import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonRouterLink,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { VxErrorComponent } from '@libs/core/lib/error-view/error-view.component';
import { PWAInstallStore } from '@libs/core/lib/pwa/pwa-install.store';

import { PwaInstallButtonComponent } from '@libs/core/lib/pwa/pwa-install-button.component';
import { VxLoadingComponent } from '@libs/core/lib/shared/loading-state';
import { VxBlurImgComponent } from '@libs/core/lib/shared/mtjr-blur-image.component';
import { dataFromState } from '@libs/core/lib/state/async-states';
import { withCategoriesList } from '@libs/mtjr/shared/generated/entities/category/category-store-features';
import { withLandingPage } from '@libs/mtjr/shared/generated/entities/product/product-store-features';
import { Dtos } from '@libs/mtjr/shared/generated/types';
import { LanguageSwitcherStore } from '@libs/mtjr/shared/i18n/language-switcher.store';
import { VxProductCardComponent } from '@libs/mtjr/shared/products/product_card.component';
import { signalStore, withComputed } from '@ngrx/signals';
import { TranslatePipe } from '@ngx-translate/core';

export const LandingStore = signalStore(
  withCategoriesList(),
  withLandingPage(),

  withComputed((store) => ({
    sections: dataFromState(store.landingPageState, (data) => data?.sections || []),
  })),
  withComputed((store) => ({
    anyLoading: computed(
      () => store.categoriesListState().type === 'loading' || store.landingPageState().type === 'loading',
    ),
    mergedData: computed(() => {
      const categories = store.categories();
      const sections = store.sections();
      return { categories, sections };
    }),
  })),
);

@Component({
  selector: 'mac-landing',
  providers: [LandingStore],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    IonHeader,
    IonTitle,
    IonToolbar,
    IonContent,
    IonSearchbar,
    IonButton,
    IonIcon,
    IonText,
    VxLoadingComponent,
    VxErrorComponent,
    VxProductCardComponent,
    RouterLink,
    IonRouterLink,
    TranslatePipe,
    PwaInstallButtonComponent,
    VxBlurImgComponent,
  ],
  templateUrl: './landing.page.html',
})
export class LandingPage {
  router = inject(Router);
  store = inject(LandingStore);
  languageSwitcherStore = inject(LanguageSwitcherStore);
  pwaInstallStore = inject(PWAInstallStore);

  constructor() {
    this.store.categoriesListPage();
    this.store.landingPage();
  }

  navigateToSection(section: Dtos.Section) {
    if (section.vendors) {
      if (section.viewAllFilter) {
        this.router.navigate(['/vendors'], {
          queryParams: {
            filter: section.viewAllFilter,
            title: section.title,
          },
        });
      }
    } else if (section.products) {
      if (section.viewAllFilter) {
        this.router.navigate(['/products'], {
          queryParams: {
            filter: section.viewAllFilter,
            title: section.title,
          },
        });
      }
    }
  }

  handleSearchInput(search?: string | null) {
    console.log({ search });

    if (search) {
      this.router.navigate(['/products'], {
        queryParams: { search: search.trim() },
      });
    }
  }
}
